const EDITION_MAP = {
  basic: "Basic",
  base: "Basic",
  "3cx base": "Basic",
  "3cx basic": "Basic",
  professional: "Professional",
  pro: "Professional",
  "3cx pro": "Professional",
  "3cx professional": "Professional",
  enterprise: "Enterprise",
  "3cx ai": "Enterprise",
  enterpriseplus: "Enterprise",
  "enterprise plus": "Enterprise",
  "3cx enterprise": "Enterprise",
};

export function normalizeEdition(value) {
  if (!value) return "Basic";
  const key = String(value).trim().toLowerCase();
  return EDITION_MAP[key] || String(value).trim();
}

export function formatEdition(value) {
  const normalized = normalizeEdition(value);
  if (normalized === "Basic") return "3CX Basic";
  if (normalized === "Professional") return "3CX PRO";
  if (normalized === "Enterprise") return "3CX AI";
  return normalized;
}

export function formatExpiresInDays(isoString, now = new Date()) {
  if (!isoString) return "-";
  const expiry = new Date(isoString);
  if (Number.isNaN(expiry.getTime())) return "-";

  const msPerDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.ceil((expiry.getTime() - now.getTime()) / msPerDay);

  if (diffDays < 0) return "Expired";
  if (diffDays === 1) return "1 day";
  return `${diffDays} days`;
}

export function formatDate(isoString) {
  if (!isoString) return "-";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return isoString;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function getExtensionsValue(licence) {
  const raw =
    licence?.Extensions ??
    licence?.Extension ??
    licence?.extensions ??
    licence?.extensionCount ??
    0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}
